import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { NFeEntradaEstadoIntegracaoRequest } from '../../requests/repo-dfe/nfe-entrada-estado-integracao.request';
import { NFeEntradaEstadoIntegracaoResponse } from '../../responses/repo-dfe/nfe-entrada-estado-integracao.response';
import { NFeEntradaLookupResponse } from '../../responses/repo-dfe/nfe-entrada-lookup.response';
import { NFeEntradaObterResponse } from '../../responses/repo-dfe/nfe-entrada-obter.response';
import { NFeEntradaUltimasComprasListarResponse } from '../../responses/repo-dfe/nfe-entrada-ultimas-compras-listar.response';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({ providedIn: 'root' })
export class NFeEntradaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFe + 'NFeEntrada';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public obterPorId(idNFeEntrada: number): Observable<NFeEntradaObterResponse> {
    return this.httpClient
      .get<NFeEntradaObterResponse>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(idNFeEntrada: number): Observable<ReturnStruct> {
    return this.httpClient
      .delete<ReturnStruct>(`${this.apiUrl}/idNFeEntrada/${idNFeEntrada}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluirEmLote(idsNFeEntrada: number[]): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/bulk-excluir`, { idsNFeEntrada }, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /** Estoque e financeiro lançados (flags da nota) das NF-es informadas, numa consulta só. */
  public estadoIntegracao(request: NFeEntradaEstadoIntegracaoRequest): Observable<NFeEntradaEstadoIntegracaoResponse> {
    return this.httpClient
      .post<NFeEntradaEstadoIntegracaoResponse>(`${this.apiUrl}/estadoIntegracao`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLookup(): Observable<NFeEntradaLookupResponse> {
    return this.httpClient
      .get<NFeEntradaLookupResponse>(`${this.apiUrl}/getLookup`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public listarUltimasCompras(idPessoaEmitente: number, idNFeEntradaAtual: number | null): Observable<NFeEntradaUltimasComprasListarResponse> {
    const parametros = idNFeEntradaAtual ? `?idNFeEntradaAtual=${idNFeEntradaAtual}` : '';
    return this.httpClient
      .get<NFeEntradaUltimasComprasListarResponse>(
        `${this.apiUrl}/ultimasCompras/idPessoaEmitente/${idPessoaEmitente}${parametros}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
